class FreeTrialRequest {
    constructor() {
        this.freeTrialRequestFormValidation();

        new FreeTrialEvent().push(1, 'click_create_account');
    }
    freeTrialRequestFormValidation(){
        let thisEvent = this;
        let form = document.getElementById('frm-freeTrialRequestForm-freeTrialRequestForm');
        if(form){
            let submitButton = document.getElementById('free_trial_request_form_submit');

            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'email': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                regexp: {
                                    regexp: /^(?:[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/,
                                    message: 'Please enter a valid email',
                                },
                                stringLength: {
                                    max: 45,
                                    message: 'Email must be less than 45 characters',
                                },
                            },
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        // Validate fields when clicking the Submit button
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        })
                    }
                }
            );

            submitButton.addEventListener('click', function (e) {
                // Prevent default button action
                e.preventDefault();
                validator.validate().then(function(status) {
                    if(status === 'Valid'){
                        new FreeTrialEvent().push(2, 'fill_email');
                        // Show loading indication
                        submitButton.setAttribute('data-kt-indicator', 'on');
                        // Disable button to avoid multiple click
                        submitButton.disabled = true;
                        grecaptcha.ready(function() {
                            grecaptcha.execute('6LeM1SIeAAAAAPtFxbwdxqZxpqSHYe71aXVaecFP', { action: 'subscribe_newsletter' }).then(function(token) {
                                let freeTrialRequestForm = $('#frm-freeTrialRequestForm-freeTrialRequestForm');
                                freeTrialRequestForm.prepend('<input type="hidden" name="tokenRecaptcha" value="' + token + '">');
                                freeTrialRequestForm.prepend('<input type="hidden" name="action" value="subscribe_newsletter">');
                                // Submit form
                                form.submit();
                            });
                        });
                    }
                });
            });
        }
    }
}

window.FreeTrialRequest = FreeTrialRequest;